import { render, staticRenderFns } from "./I18nTooltip.vue?vue&type=template&id=20539850&scoped=true&"
import script from "./I18nTooltip.vue?vue&type=script&lang=js&"
export * from "./I18nTooltip.vue?vue&type=script&lang=js&"
import style0 from "./I18nTooltip.vue?vue&type=style&index=0&id=20539850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20539850",
  null
  
)

export default component.exports